var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticStyle:{"width":"150px","text-align":"center"},attrs:{"placeholder":_vm.placeholder}})
}
var staticRenderFns = []

export { render, staticRenderFns }